module.exports = __webpack_public_path__ + "static/media/dirt_camo.4623c01b.jpg";